
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ProductGroupEdit from '@/components/ProductGroup/ProductGroupEdit.vue';

@Component({
  components: {
    ProductGroupEdit,
  },
})
export default class ProductGroupEditButton extends Vue {
  @Prop(String) private id!: string;
  private showDialog = false;

  @Emit()
  private productGroupUpdated() {
    this.showDialog = false;
  }
}
